import { createContext, useContext } from "react";
import { Layout } from "../../types/layout";

export type LayoutState = {
  layout: Layout;
  isMobile: boolean;
};

export const LayoutContext = createContext<LayoutState | undefined>(undefined);

export const useLayout = () => {
  const context = useContext(LayoutContext);

  if (context === undefined) {
    throw new Error("useLayout must be used within a LayoutProvider provider.");
  }

  return context;
};
